import '../scss/app.scss';

import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/tag/tag.js';

import { Offcanvas } from 'bootstrap';

const $ = jQuery;
window.galleryItems = [];

$(document).ready(function() {
	// Initialize FitVids
	$('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids({ maxWidth: 1024 });
  $('.fluid-width-video-wrapper').removeClass('hidden');
});

$(document).ready(function() {
	$('.header-navigation-wrapper .menu-item-has-children').hover(function() {
		$(this).children('.sub-menu').stop().slideToggle({
			duration: 200,
			start: function() {
				$(this).css({'display': 'flex'});
			},
		});
	});

  const menuTop = $('.header-navigation-wrapper').offset().top;
	let subMenuTop = 0;
	if ($('.submenu-container').length) {
		subMenuTop = $('.submenu-container').offset().top - $('.header-navigation-wrapper').height();
	}
	const stickyMenu = function() {
		let scrollTop = $(window).scrollTop() - $('#main-nav').height() + 18;
		const wpAdminBar = $('#wpadminbar').height() || 0;
		scrollTop = scrollTop + wpAdminBar;
		if (scrollTop > menuTop) {
			$('header.navigation .container').addClass('sticky');
			$('body').css('margin-top', $('.header-logo-wrapper').height() + $('.header-navigation-wrapper').height() + $('#main-nav').height() - 12 - 6);
			$('.header-navigation-wrapper').css('margin-top', wpAdminBar);
		}
		else {
			$('header.navigation .container').removeClass('sticky');
			$('body').css('margin-top', 0);
			$('.header-navigation-wrapper').css('margin-top', 0);
		}
	};
	const stickySubMenu = function() {
		if (subMenuTop == 0) {
			return;
		}
		let scrollTop = $(window).scrollTop();
		if ($('#wpadminbar').length) {
			scrollTop = scrollTop + $('#wpadminbar').height();
		}
		if (scrollTop > subMenuTop) {
			$('.submenu-container').addClass('sticky');
			$('.submenu-container').css('top', menuTop - $('.header-navigation-wrapper').height() + 10);
			$('.featured-image').attr('style', 'margin-bottom: ' + $('.submenu-container').height() + 'px !important');
		}
		else {
			$('.submenu-container').removeClass('sticky');
			$('.submenu-container').css('top', '0');
			$('.featured-image').css('margin-bottom', '0');
		}
	};
	// stickyMenu();
	// stickySubMenu();

	$(window).scroll(function() {
		// stickyMenu();
		// stickySubMenu();
	});

	function trd_submenu_scroll_to(el) {
		$('html, body').animate({
			scrollTop: $('#' + el).offset().top - 60
		}, 500);
	}

	$('.sticky-submenu a').click(function(e) {
		e.preventDefault();
		trd_submenu_scroll_to($(this).attr('href').split('#')[1]);
	});

	$('.sub-navigation a').click(function(e) {
		e.preventDefault();
		trd_submenu_scroll_to($(this).attr('href').split('#')[1]);
	});

	$('.section-image-with-text-box .box-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
	});
});
